(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-area', {
            parent: 'entity',
            url: '/ss-area',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSAreas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-area/s-s-areas.html',
                    controller: 'SSAreaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-area-detail', {
            parent: 'ss-area',
            url: '/ss-area/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSArea'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-area/ss-area-detail.html',
                    controller: 'SSAreaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSArea', function($stateParams, SSArea) {
                    return SSArea.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-area',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-area-detail.edit', {
            parent: 'ss-area-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-dialog.html',
                    controller: 'SSAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSArea', function(SSArea) {
                            return SSArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-area.new', {
            parent: 'ss-area',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-dialog.html',
                    controller: 'SSAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-area', null, { reload: 'ss-area' });
                }, function() {
                    $state.go('ss-area');
                });
            }]
        })
        .state('ss-area.edit', {
            parent: 'ss-area',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-dialog.html',
                    controller: 'SSAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSArea', function(SSArea) {
                            return SSArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-area', null, { reload: 'ss-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-area.delete', {
            parent: 'ss-area',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-area/ss-area-delete-dialog.html',
                    controller: 'SSAreaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSArea', function(SSArea) {
                            return SSArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-area', null, { reload: 'ss-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
